// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/WhatsappMessageTemplates_GetTemplatesByFranchisesForSelectionInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/whatsapp_message_templates/get_templates_by_franchises_for_selection
 *
 * Fetches WhatsApp message templates for selection dropdown by franchise IDs.
 * Deduplicates templates across franchises.
 * Read endpoint that accepts POST body for filtering.
 */
import { registerContract } from './validate'

export interface WhatsappMessageTemplates_GetTemplatesByFranchisesForSelectionInput {
franquia_ids: number[]
}

registerContract('WhatsappMessageTemplates_GetTemplatesByFranchisesForSelectionInput', {
  franquia_ids: { type: 'array',   required: true },
})
